import { Routes } from '@angular/router';
import { DefaultLayoutComponent, EmailLayoutComponent } from './layout';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'apps/email',
    component: EmailLayoutComponent,

    children: [
      {
        path: '',
        loadChildren: () => import('./views/apps/email/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [authGuard],
    data: {
      title: ''
    },
    children: [
      
      {
        path: 'Settings',
        loadChildren: () => import('./views/cruds/cruds.module').then((m) => m.CRUDSModule)
      },
      {
        path: 'upload',
        loadChildren: () => import('./views/excel-data/excel-data.module').then((m) => m.ExcelDataModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/routes').then((m) => m.routes)
      },
      {
        path: 'base',
        loadChildren: () => import('./views/base/routes').then((m) => m.routes)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/routes').then((m) => m.routes)
      },
      {
        path: 'forms',
        loadChildren: () => import('./views/forms/routes').then((m) => m.routes)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/routes').then((m) => m.routes)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/routes').then((m) => m.routes)
      },
      {
        path: 'smart-table',
        loadChildren: () => import('./views/smart-tables/routes').then((m) => m.routes)
      },
      {
        path: 'plugins',
        loadChildren: () => import('./views/plugins/routes').then((m) => m.routes)
      },
      {
        path: 'pages',
        loadChildren: () => import('./views/pages/routes').then((m) => m.routes)
      },
      {
        path: 'apps',
        loadChildren: () => import('./views/apps/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  {
    // Break-glass super-admin login (bypasses OneGate). Type the URL directly.
    path: 'superadmin/login',
    loadComponent: () => import('./views/pages/superadmin-login/superadmin-login.component').then(m => m.SuperadminLoginComponent),
    data: { title: 'Super Admin' }
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
  {
    path: 'sso',
    loadComponent: () => import('./views/pages/sso/sso.component').then(m => m.SsoComponent),
    data: {
      title: 'Single Sign-On'
    }
  },
  {
    path: 'sso/:token',
    loadComponent: () => import('./views/pages/sso/sso.component').then(m => m.SsoComponent),
    data: {
      title: 'Single Sign-On'
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];
